<!-- filepath: c:\Users\lawi\Sandbox\loop_reporting_feb\frontend\src\componentsv3\WaveBoard\WaveHeader.vue -->
<template>
  <div class="wave-header">
    <div class="header-content">
      <div class="header-title-group">
        <Activity :size="20" class="header-icon" />
        <h4 class="header-title">{{ title }}</h4>
      </div>

      <!-- showDetailButton ||  -->
      <button
        v-if="false"
        class="detail-button"
        @click="$emit('detail-click')">
        <ChevronRight :size="16" />
      </button>
    </div>

    <p v-if="description" class="header-description">
      {{ description }}
    </p>
  </div>
</template>

<script>
import { Activity, ChevronRight } from 'lucide-vue-next';

export default {
  name: 'WaveHeader',

  components: {
    Activity,
    ChevronRight
  },

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: null
    },
    showDetailButton: {
      type: Boolean,
      default: true
    }
  },

  emits: ['detail-click']
}
</script>

<style lang="scss" scoped>
.wave-header {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.header-icon {
  color: var(--bs-primary);
  flex-shrink: 0;
}

.header-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--bs-body-color);
  margin: 0;
}

.header-description {
  font-size: 0.875rem;
  color: var(--bs-secondary-color);
  margin: 0;
  line-height: 1.5;
}

.detail-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  color: var(--bs-secondary-color);
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: var(--bs-secondary-bg);
    color: var(--bs-body-color);
  }

  &:active {
    transform: scale(0.98);
  }
}
</style>
